import { memo, useEffect, useState } from 'react';

import styles from './yAxis.module.scss';

interface YAxisProps {
  maxValue: number;
}

const STEP = 200;

function createNumberArray(maxValue: number, step: number): number[] {
  const result = [];
  for (let i = maxValue; i >= 0; i -= step) {
    result.push(i);
  }
  return result;
}

export const YAxisComponent = ({ maxValue }: YAxisProps) => {
  const [yLabels, setYlabels] = useState<number[]>([]);

  useEffect(() => {
    setYlabels(createNumberArray(maxValue, STEP));
  }, [maxValue]);

  return (
    <ul className={styles.axis}>
      {yLabels.map((label) => (
        <li key={label} className={styles.label}>
          ${label}M
        </li>
      ))}
    </ul>
  );
};

export const YAxis = memo(YAxisComponent);
